// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__do_iy","footer":"styles_footer__362dy"};